<template>
<console-content>
    <v-layout v-if="ready" justify-center class="py-4">
        <v-responsive width="100%" max-width="1280">
            <v-layout wrap>
                <v-flex xs6 md3 class="pa-2">
                    <dashboard-card label="주문" :icon="mdiReceipt" height="150" color="teal lighten-3">
                        <v-card-text class="font-size-14">
                            <v-layout>총 주문건수<v-spacer/><router-link to="/console/shop/purchases/order"><b class="teal--text text--lighten-3">{{ dashboard.shop.summary.totalCount }}</b></router-link>건</v-layout>
                            <v-layout class="mt-1">신규주문<v-spacer/><router-link :to="`/console/shop/purchases/purchase?createdAt=${$dayjs().format('YYYY-MM-DD')}&createdAt=${$dayjs().format('YYYY-MM-DD')}`"><b class="teal--text text--lighten-3">{{ dashboard.shop.summary.newOrderCount }}</b></router-link>건</v-layout>
                            <v-layout class="mt-1">상품준비중<v-spacer/><router-link to="/console/shop/purchases/order?status=상품준비중"><b class="teal--text text--lighten-3">{{ dashboard.shop.summary.orderConfirmationCount }}</b></router-link>건</v-layout>
                        </v-card-text>
                    </dashboard-card>
                </v-flex>
                <v-flex xs6 md3 class="pa-2">
                    <dashboard-card label="배송" :icon="mdiTruckFast" height="150" color="purple lighten-3">
                        <v-card-text class="font-size-14">
                            <v-layout>배송중<v-spacer/><router-link to="/console/shop/purchases/shipping?status=배송중"><b class="purple--text text--lighten-3">{{ dashboard.shop.summary.shippingCount }}</b></router-link>건</v-layout>
                            <v-layout class="mt-1">배송완료<v-spacer/><router-link to="/console/shop/purchases/shipping?status=배송완료"><b class="purple--text text--lighten-3">{{ dashboard.shop.summary.deliveredCount }}</b></router-link>건</v-layout>
                        </v-card-text>
                    </dashboard-card>
                </v-flex>
                <v-flex xs6 md3 class="pa-2">
                    <dashboard-card label="취소·교환·반품" :icon="mdiUndoVariant" height="150" color="blue-grey lighten-1">
                        <v-card-text class="font-size-14">
                            <v-layout>취소요청<v-spacer/><router-link to="/console/shop/purchases/cancel?status=취소요청"><b class="blue-grey--text text--lighten-1">{{ dashboard.shop.summary.cancelRequestCount }}</b></router-link>건</v-layout>
                            <v-layout v-show="false" class="mt-1">교환요청<v-spacer/><router-link to="/console/shop/purchases/exchange?status=교환요청"><b class="blue-grey--text text--lighten-1">{{ dashboard.shop.summary.exchangeRequestCount }}</b></router-link>건</v-layout>
                            <v-layout class="mt-1">반품요청<v-spacer/><router-link to="/console/shop/purchases/return?status=반품요청"><b class="blue-grey--text text--lighten-1">{{ dashboard.shop.summary.returnRequestCount }}</b></router-link>건</v-layout>
                        </v-card-text>
                    </dashboard-card>
                </v-flex>
                <v-flex xs6 md3 class="pa-2">
                    <dashboard-card label="구매확정" :icon="mdiCalculatorVariant" height="150" color="light-blue lighten-2">
                        <v-card-text class="font-size-14">
                            <v-layout>구매확정<v-spacer/><router-link to="/console/shop/purchases/complete"><b class="blue--text text--lighten-2">{{ dashboard.shop.summary.purchasedCount }}</b></router-link>건</v-layout>
                        </v-card-text>
                    </dashboard-card>
                </v-flex>
            </v-layout>

            <v-layout wrap>
                <v-flex xs12 md6 class="pa-2">

                    <dashboard-card label="회원현황" :icon="mdiAccountSupervisorCircle" color="red">
                        <v-divider/>
                        <v-data-table :items="members" :headers="membersHeaders" hide-default-footer disable-sort>
                            <template slot="item.new" slot-scope="{item}">
                                <v-icon v-if="$dayjs(item.createdAt).format('YYYY-MM-DD') == $dayjs().format('YYYY-MM-DD')" small color="amber darken-1">{{ mdiAlphaNBox }}</v-icon>
                            </template>
                            <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                        </v-data-table>
                        <v-divider/>
                    </dashboard-card>

                    <v-layout class="mx-n1 mt-4">
                        <v-flex xs6 class="px-1">
                            <v-card>
                                <v-card-actions class="font-size-14 pa-4">
                                    <span>오늘 가입한 회원</span>
                                    <v-spacer/>
                                    <span><router-link :to="`/console/members?createdAt=${$dayjs().format('YYYY-MM-DD')}&createdAt=${$dayjs().format('YYYY-MM-DD')}`"><b class="red--text">{{ membersSummary.todayRegisteredCount }}</b></router-link>명</span>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 class="px-1">
                            <v-card>
                                <v-card-actions class="font-size-14 pa-4">
                                    <span>전체 회원수</span>
                                    <v-spacer/>
                                    <span><router-link to="/console/members"><b class="red--text">{{ membersSummary.totalCount }}</b></router-link>명</span>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-layout class="mx-n1 mt-2">
                        <v-flex xs6 class="px-1">
                            <v-card>
                                <v-card-actions class="font-size-14 pa-4">
                                    <span>오늘 탈퇴회원</span>
                                    <v-spacer/>
                                    <span><router-link :to="`/console/member/withdrawals?withdrawnAt=${$dayjs().format('YYYY-MM-DD')}&withdrawnAt=${$dayjs().format('YYYY-MM-DD')}`"><b class="red--text">{{ membersSummary.todaywithdrawnCount }}</b></router-link></span>명</span>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 class="px-1">
                            <v-card>
                                <v-card-actions class="font-size-14 pa-4">
                                    <span>총 탈퇴회원</span>
                                    <v-spacer/>
                                    <span><router-link to="/console/member/withdrawals"><b class="red--text">{{ membersSummary.totalWithdrawnCount }}</b></router-link>명</span>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <dashboard-card label="월별매출통계" :icon="mdiChartLine" color="indigo lighten-1" class="mt-4">
                        <dashboard-chart :x-axis-data="monthlyStatistics.xAxisData" :data="monthlyStatistics.amount"/>
                    </dashboard-card>

                    <v-layout class="mt-2 mx-n2">
                        <v-flex xs6 class="pa-2">
                            <dashboard-card label="일별결제금액" :icon="mdiChartBar" color="blue lighten-2">
                                <dashboard-chart :x-axis-data="dailyStatistics.xAxisData" :data="dailyStatistics.amount"/>
                            </dashboard-card>
                        </v-flex>
                        <v-flex xs6 class="pa-2">
                            <dashboard-card label="일별결제건수" :icon="mdiChartBar" color="blue lighten-2">
                                <dashboard-chart :x-axis-data="dailyStatistics.xAxisData" :data="dailyStatistics.count"/>
                            </dashboard-card>
                        </v-flex>
                    </v-layout>

                    <v-layout class="mt-2 mx-n2">
                        <v-flex xs6 class="pa-2">
                            <dashboard-card label="일별결제자수" :icon="mdiChartBar" color="blue lighten-2">
                                <dashboard-chart :x-axis-data="dailyStatistics.xAxisData" :data="dailyStatistics.buyer"/>
                            </dashboard-card>
                        </v-flex>
                        <v-flex xs6 class="pa-2">
                            <dashboard-card label="요일별 매출통계" :icon="mdiChartTimelineVariant" color="cyan">
                                <dashboard-graph :data="daysOfTheWeek" />
                            </dashboard-card>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 md6 class="pa-2">

                    <dashboard-card label="1:1 문의" :icon="mdiHelpCircle" color="amber">
                        <v-divider/>
                        <v-data-table :items="questions" :headers="questionsHeaders" hide-default-footer disable-sort>
                            <template slot="item.subject" slot-scope="{item}">
                                <router-link :to="`/console/center/questions/${item._id}`">{{ item.subject }} <v-icon v-if="$dayjs(item.createdAt).format('YYYY-MM-DD') == $dayjs().format('YYYY-MM-DD')" small color="amber darken-1">{{ mdiAlphaNBox }}</v-icon></router-link>
                            </template>
                            <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                        </v-data-table>
                    </dashboard-card>

                    <dashboard-card label="공지사항" :icon="mdiBellRing" color="orange" class="mt-4">
                        <v-divider/>
                        <v-data-table :items="notifications" :headers="notificationsHeaders" hide-default-footer disable-sort>
                            <template slot="item.subject" slot-scope="{item}">
                                <router-link :to="`/console/center/notifications/${item._id}`">{{ item.subject }} <v-icon v-if="$dayjs(item.createdAt).format('YYYY-MM-DD') == $dayjs().format('YYYY-MM-DD')" small color="amber darken-1">{{ mdiAlphaNBox }}</v-icon></router-link>
                            </template>
                            <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                        </v-data-table>
                    </dashboard-card>

                    <dashboard-card label="상품문의" :icon="mdiHeadset" color="blue" class="mt-4">
                        <v-divider/>
                        <v-data-table :items="inquires" :headers="inquiresHeaders" hide-default-footer disable-sort>
                            <template slot="item.content" slot-scope="{item}">
                                <router-link :to="`/console/shop/inquires/${item._id}`">{{ item.content }} <v-icon v-if="$dayjs(item.createdAt).format('YYYY-MM-DD') == $dayjs().format('YYYY-MM-DD')" small color="amber darken-1">{{ mdiAlphaNBox }}</v-icon></router-link>
                            </template>
                            <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                        </v-data-table>
                    </dashboard-card>
                </v-flex>
            </v-layout>
        </v-responsive>
    </v-layout>
</console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import DashboardCard from "@/components/console/dashboard/dashboard-card.vue";
import DashboardChart from "@/components/console/dashboard/dashboard-chart.vue";
import DashboardGraph from "@/components/console/dashboard/dashboard-graph.vue";

import { mdiReceipt, mdiTruckFast, mdiUndoVariant, mdiCalculatorVariant, mdiMicrosoftExcel, mdiChartLine, mdiChartBar, mdiChartTimelineVariant, mdiAccountSupervisorCircle, mdiHelpCircle, mdiHeadset, mdiBellRing, mdiClipboardEdit, mdiAlphaNBox} from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        DashboardCard,
        DashboardChart,
        DashboardGraph,
    },
    data(){
        return {
            mdiReceipt,
            mdiTruckFast,
            mdiUndoVariant,
            mdiChartBar,
            mdiChartLine,
            mdiMicrosoftExcel,
            mdiCalculatorVariant,
            mdiChartTimelineVariant,
            mdiAccountSupervisorCircle,
            mdiAlphaNBox,
            mdiClipboardEdit,
            mdiBellRing,
            mdiHeadset,
            mdiHelpCircle,

            showSearch: true,

            filter: {},

            ready: false,

            dashboard: null,

            // 회원
            membersSummary: { totalCount: 0 },
            members: [],
            membersHeaders: [
                { text: "아이디", value: "username", align: "center" },
                { text: "이름", value: "name", align: "center" },
                { text: "과금등급", value: "riskManagement.giftcard.level", align: "center", width: 100 },
                { text: "가입일자", value: "createdAt", align: "center", width: 120 },
            ],

            inquiresSummary: { totalCount: 0 },
            inquires: [],
            inquiresHeaders: [
                { text: "문의내용", value: "content", align: "start" },
                { text: "작성자", value: "writer.name", align: "center", width: 100 },
                { text: "작성일자", value: "createdAt", align: "center", width: 120 },
            ],

            questionsSummary: { totalCount: 0 },
            questions: [],
            questionsHeaders: [
                { text: "제목", value: "subject", align: "start" },
                { text: "작성자", value: "member.name", align: "center", width: 100 },
                { text: "작성일자", value: "createdAt", align: "center", width: 120 },
            ],

            notificationsSummary: { totalCount: 0 },
            notifications: [],
            notificationsHeaders: [
                { text: "제목", value: "subject", align: "start" },
                { text: "작성자", value: "writer.name", align: "center", width: 100 },
                { text: "작성일자", value: "createdAt", align: "center", width: 120 },
            ],

            boardsSummary: { totalCount: 0 },
            boards: [],
            boardsHeaders: [
                { text: "제목", value: "subject", align: "start", /* width: 10 */ },
                { text: "작성자", value: "writer.name", align: "center", width: 100 },
                { text: "작성일자", value: "createdAt", align: "center", width: 120 },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { dashboard } = await api.console.dashboard.get();
            this.dashboard = dashboard;

            var { summary, members } = await api.console.members.gets({ headers: { limit: 5 }, params: { isWithdrawal: false } });
            this.membersSummary = summary;
            this.members = members;

            var { summary, inquires } = await api.console.shop.inquires.gets({ headers: { limit: 5 } });
            this.inquiresSummary = summary;
            this.inquires = inquires;

            var { summary, questions } = await api.console.center.questions.gets({ headers: { limit: 5 } });
            this.questionsSummary = summary;
            this.questions = questions;

            var { summary, notifications } = await api.console.center.notifications.gets({ headers: { limit: 5 } });
            this.notificationsSummary = summary;
            this.notifications = notifications;

            var { summary, boards } = await api.console.boards.gets({ headers: { limit: 5 } });
            this.boardsSummary = summary;
            this.boards = boards;

            this.ready = true;
        }
    },

    computed: {
        monthlyStatistics(){
            let statistics = this.dashboard?.shop?.statistics || [];
            let xAxisData = statistics.map(statistic => statistic.ym) || [];
            let amount = statistics.map(statistic => statistic.amount) || [];

            return {
                xAxisData,
                amount
            }
        },

        dailyStatistics(){
            let statistics = this.dashboard?.shop?.statistics?.reduce?.(( dailyStatistics, monthlyStatistic ) => {
                return [...dailyStatistics, ...monthlyStatistic.daily ]
            }, []) || [];

            let xAxisData = statistics.map(statistic => statistic.ymd) || [];
            let amount = statistics.map(statistic => statistic.amount) || [];
            let count = statistics.map(statistic => statistic.count) || [];
            let buyer = statistics.map(statistic => statistic.buyer) || [];

            return {
                xAxisData,
                amount,
                count,
                buyer,
            }
        },

        daysOfTheWeek(){
            return this.dashboard?.shop?.daysOfTheWeek || [];
        }
    }
}
</script>